document.addEventListener("DOMContentLoaded", function () {
  /* =========================================================
     CONFIG
  ========================================================= */

  const CONFIG = {
    affiliateEndpoint:
      "https://hydrinity-affiliate-proxy-three.vercel.app/api/affiliates?token=pk_FltUQeX3z27T1BKzyCHzIG7sWC3AJblg",

    cookieName: "sca_ref",
    cookieDays: 30,

    providerStorageKey: "sca_ref",
    providerExpiryKey: "sca_ref_expires",
    providerCacheDays: 30,

    cacheKey: "hydrinity_affiliates",
    cacheDuration: 15 * 60 * 1000,

    searchDebounce: 150,
    observerDebounce: 75,
    maxSearchResults: 50,

    providerSelectors:
      "#selected-provider, #selectedprovider, [data-selected-provider], #selected-provider2"
  };


  /* =========================================================
     BASIC HELPERS
  ========================================================= */

  const $ = (id) => document.getElementById(id);

  const getStepTwo = () => $("stepTwo");
  const getStepTwoBtn = () => $("cart--step-2-button");

  const getSelProv1 = () =>
    $("selected-provider") ||
    $("selectedprovider") ||
    document.querySelector("[data-selected-provider]");

  const getSelProv2 = () => $("selected-provider2");

  const getWithProvBtn = () => $("withProviderBtn");
  const getNewProvBtn = () => $("newProviderBtn");

  const getEditCart = () =>
    $("editCart") ||
    $("editcart");

  const getAffiliateCta = () =>
    $("affiliateCheckout") ||
    $("affilateCheckout");

  const getCartItems = () => $("cartItems");
  const getNoProvBtn = () => $("withoutProvider");
  const getClinicInput = () => $("clinic-input");
  const getClinicList = () => $("clinic-results");
  const getProvHeading = () => $("providerHeading");


  function forceShow(el) {
    if (!el) return;

    el.classList.remove("hidden");
    el.removeAttribute("hidden");
    el.style.removeProperty("display");
    el.style.removeProperty("visibility");
  }


  function forceHide(el) {
    if (!el) return;

    el.classList.add("hidden");
    el.setAttribute("hidden", "");
    el.style.setProperty("display", "none", "important");
    el.style.setProperty("visibility", "hidden", "important");
  }


  function debounce(fn, delay = 150) {
    let timer;

    return function (...args) {
      clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }


  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function waitForEl(selector, { timeout = 4000 } = {}) {
    return new Promise((resolve) => {
      const existing = document.querySelector(selector);

      if (existing) {
        resolve(existing);
        return;
      }

      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);

        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, timeout);
    });
  }


  /* =========================================================
     COOKIE / PROVIDER REF HELPERS
  ========================================================= */

  function getCookie(name) {
    const prefix = encodeURIComponent(name) + "=";

    const item = document.cookie
      .split(";")
      .map((item) => item.trim())
      .find((item) => item.startsWith(prefix));

    if (!item) return null;

    return decodeURIComponent(item.slice(prefix.length));
  }


  function setCookie(name, value, days = 30) {
    if (!value) return;

    const maxAge = Math.max(1, Number(days) || 30) * 86400;

    let cookie =
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
      `; Path=/` +
      `; Max-Age=${maxAge}` +
      `; SameSite=Lax`;

    if (location.protocol === "https:") {
      cookie += "; Secure";
    }

    document.cookie = cookie;
  }


  function removeCookie(name) {
    document.cookie =
      `${encodeURIComponent(name)}=` +
      `; Path=/` +
      `; Max-Age=0` +
      `; SameSite=Lax`;
  }


  function getUrlParam(key) {
    const search = new URLSearchParams(location.search);

    const hashParams = new URLSearchParams(
      location.hash.replace(/^#\?/, "")
    );

    return search.get(key) || hashParams.get(key);
  }


  function baseRef(value) {
    const str = String(value || "").trim();

    if (!str) return "";

    const numeric = str.match(/^\d+/);

    if (numeric) {
      return numeric[0];
    }

    return str
      .split(".")[0]
      .split(/[^A-Za-z0-9_-]/)[0];
  }


  function getExplicitScaRef() {
    /*
     * URL always takes priority.
     */
    const urlRef = getUrlParam("sca_ref");

    if (urlRef) {
      return urlRef.trim();
    }


    /*
     * Check localStorage and its expiry.
     */
    try {
      const storedRef =
        localStorage.getItem(
          CONFIG.providerStorageKey
        );

      const expiresAt =
        parseInt(
          localStorage.getItem(
            CONFIG.providerExpiryKey
          ),
          10
        );


      if (
        storedRef &&
        expiresAt &&
        Date.now() < expiresAt
      ) {
        return storedRef.trim();
      }


      /*
       * Expired or invalid localStorage value.
       */
      if (storedRef || expiresAt) {
        localStorage.removeItem(
          CONFIG.providerStorageKey
        );

        localStorage.removeItem(
          CONFIG.providerExpiryKey
        );
      }
    } catch (error) {
      console.warn(
        "[Affiliate] Unable to read provider storage:",
        error
      );
    }


    /*
     * Cookie fallback.
     * Browser automatically expires this after 30 days.
     */
    const cookieRef =
      getCookie(CONFIG.cookieName);

    if (cookieRef) {
      return cookieRef.trim();
    }


    return "";
  }


  function storeScaRef(ref) {
    ref = String(ref || "").trim();

    if (!ref) return;


    const expiresAt =
      Date.now() +
      CONFIG.providerCacheDays *
        24 *
        60 *
        60 *
        1000;


    try {
      localStorage.setItem(
        CONFIG.providerStorageKey,
        ref
      );

      localStorage.setItem(
        CONFIG.providerExpiryKey,
        String(expiresAt)
      );
    } catch (error) {
      console.warn(
        "[Affiliate] Unable to store provider:",
        error
      );
    }


    setCookie(
      CONFIG.cookieName,
      ref,
      CONFIG.cookieDays
    );
  }


  function removeScaRef() {
    try {
      localStorage.removeItem(
        CONFIG.providerStorageKey
      );

      localStorage.removeItem(
        CONFIG.providerExpiryKey
      );
    } catch {}


    removeCookie(
      CONFIG.cookieName
    );
  }


  /* =========================================================
     CHECKOUT REDIRECT STATE
  ========================================================= */

  if (sessionStorage.getItem("redirectToCheckout") === "true") {
    sessionStorage.removeItem("redirectToCheckout");

    const loader = $("checkout-loading-screen");

    if (loader) {
      loader.classList.remove("hidden");
    }

    setTimeout(() => {
      window.location.href = "/checkout";
    }, 3000);

    return;
  }


  /* =========================================================
     STATE
  ========================================================= */

  let clinics = [];
  let clinicsLoaded = false;
  let clinicsLoading = false;
  let clinicsError = null;

  let clinicsPromise = null;

  let currentClinic = null;
  let currentFullRef = "";

  let observerTimer = null;


  /* =========================================================
     API
  ========================================================= */

  function normalizeClinicPayload(data) {
    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.affiliates)) {
      return data.affiliates;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    console.warn(
      "[Affiliate] Unexpected affiliates payload:",
      data
    );

    return [];
  }


  function getCachedClinics({
    allowExpired = false
  } = {}) {
    try {
      const cached = sessionStorage.getItem(
        CONFIG.cacheKey
      );

      if (!cached) {
        return null;
      }

      const parsed = JSON.parse(cached);

      if (!Array.isArray(parsed?.data)) {
        return null;
      }

      const age =
        Date.now() - Number(parsed.timestamp || 0);

      if (
        !allowExpired &&
        age > CONFIG.cacheDuration
      ) {
        return null;
      }

      return parsed.data;
    } catch (error) {
      console.warn(
        "[Affiliate] Invalid affiliate cache:",
        error
      );

      return null;
    }
  }


  function saveClinicsToCache(data) {
    try {
      sessionStorage.setItem(
        CONFIG.cacheKey,
        JSON.stringify({
          timestamp: Date.now(),
          data
        })
      );
    } catch (error) {
      console.warn(
        "[Affiliate] Unable to cache affiliates:",
        error
      );
    }
  }


  async function fetchAffiliateApi() {
    const response = await fetch(
      CONFIG.affiliateEndpoint,
      {
        method: "GET",
        cache: "no-store",
        credentials: "omit"
      }
    );

    if (!response.ok) {
      const error = new Error(
        `Affiliate API returned HTTP ${response.status}`
      );

      error.status = response.status;

      throw error;
    }

    const data = await response.json();

    return normalizeClinicPayload(data);
  }


  async function loadClinics() {
  /*
   * Already loaded.
   */
  if (clinicsLoaded) {
    return clinics;
  }


  /*
   * Request already running.
   */
  if (clinicsPromise) {
    return clinicsPromise;
  }


  /*
   * Use fresh session cache first.
   */
  const freshCache =
    getCachedClinics();

  if (freshCache) {
    clinics = freshCache;
    clinicsLoaded = true;
    clinicsError = null;

    return clinics;
  }


  clinicsLoading = true;
  clinicsError = null;


  clinicsPromise =
    (async () => {
      try {
        let result;


        try {
          result =
            await fetchAffiliateApi();
        } catch (firstError) {
          /*
           * NEVER retry authentication /
           * permission failures.
           *
           * Retrying a 401 just delays the page.
           */
          if (
            firstError?.status === 401 ||
            firstError?.status === 403
          ) {
            throw firstError;
          }


          /*
           * Retry temporary failures once.
           */
          console.warn(
            "[Affiliate] API request failed. Retrying once...",
            firstError
          );


          await new Promise(
            resolve =>
              setTimeout(
                resolve,
                250
              )
          );


          result =
            await fetchAffiliateApi();
        }


        clinics = result;
        clinicsLoaded = true;
        clinicsError = null;


        saveClinicsToCache(
          clinics
        );


        console.log(
          `[Affiliate] Loaded ${clinics.length} providers`
        );


        return clinics;
      } catch (error) {
        /*
         * Try stale cache before failing.
         */
        const staleCache =
          getCachedClinics({
            allowExpired: true
          });


        if (
          staleCache?.length
        ) {
          console.warn(
            "[Affiliate] API unavailable. Using cached providers."
          );


          clinics =
            staleCache;

          clinicsLoaded =
            true;

          clinicsError =
            null;


          return clinics;
        }


        clinics = [];
        clinicsLoaded = false;
        clinicsError = error;


        /*
         * Don't spam console for known 401/403.
         */
        if (
          error?.status === 401 ||
          error?.status === 403
        ) {
          console.warn(
            `[Affiliate] Provider API unavailable (${error.status}).`
          );
        } else {
          console.error(
            "[Affiliate] Failed to load providers:",
            error
          );
        }


        throw error;
      } finally {
        clinicsLoading = false;
        clinicsPromise = null;
      }
    })();


  return clinicsPromise;
}


  /* =========================================================
     STATE CHECKS
  ========================================================= */

  function isStepTwoActive() {
    const stepTwo = getStepTwo();

    return Boolean(
      stepTwo &&
      !stepTwo.classList.contains("hidden") &&
      !stepTwo.hasAttribute("hidden")
    );
  }


  function isClinicSearchActive() {
    const input = getClinicInput();
    const list = getClinicList();

    const focused =
      input &&
      document.activeElement === input;

    const open =
      list &&
      !list.classList.contains("hidden") &&
      !list.hasAttribute("hidden");

    return Boolean(focused || open);
  }


  /* =========================================================
     PROVIDER RENDERING
  ========================================================= */

  function clinicMarkup(clinic) {
    return `
      <h3 class="text-xxxl clinic-name">
        ${escapeHtml(clinic?.name)}
      </h3>

      <div class="mt-2 phone-number">
        <p>${escapeHtml(clinic?.phone)}</p>
      </div>

      <p class="address">
        ${escapeHtml(clinic?.address)}
        </br>
        ${escapeHtml(clinic?.city)},
        ${escapeHtml(clinic?.state)}
        ${escapeHtml(clinic?.zip_code)}
      </p>
    `;
  }


  function updateMessageBar(clinic) {
    if (!clinic) return;

    const bar = document.querySelector(
      ".scaaf-message-bar"
    );

    if (!bar) return;


    let msg = bar.querySelector(
      ".scaaf-message-bar-content"
    );

    if (!msg) {
      msg = document.createElement("p");
      msg.className =
        "scaaf-message-bar-content";

      bar.appendChild(msg);
    }


    msg.textContent =
      `You are shopping Hydrinity with ${clinic.name || ""}`;
  }


  function renderSelectedProviderMirrors(
    clinic,
    ref = null
  ) {
    if (!clinic) return;

    const html = clinicMarkup(clinic);

    const scaRef =
      String(
        ref ||
        currentFullRef ||
        clinic.sca_ref ||
        ""
      ).trim();


    const providers =
      document.querySelectorAll(
        CONFIG.providerSelectors
      );


    providers.forEach((host) => {
      host.innerHTML = html;

      forceShow(host);

      host.setAttribute(
        "data-sca-ref",
        scaRef
      );

      host.setAttribute(
        "data-preserve-children",
        ""
      );
    });
  }


  async function ensureStepTwoMirrorRendered() {
    if (!currentClinic) return;

    let host = getSelProv1();

    if (!host) {
      host = await waitForEl(
        "#selected-provider, #selectedprovider, [data-selected-provider]",
        {
          timeout: 2000
        }
      );
    }

    if (!host) return;


    if (
      !host.innerHTML.trim() ||
      host.getAttribute("data-sca-ref") !==
        String(
          currentFullRef ||
          currentClinic.sca_ref ||
          ""
        )
    ) {
      renderSelectedProviderMirrors(
        currentClinic,
        currentFullRef
      );
    }
  }


  /* =========================================================
     MASTER UI STATE
  ========================================================= */

  function syncUI() {
    const stepTwoBtn = getStepTwoBtn();
    const affiliateCta = getAffiliateCta();
    const noProvBtn = getNoProvBtn();
    const editCartBtn = getEditCart();

    const explicitRef =
      Boolean(getExplicitScaRef());

    const stepTwoOpen =
      isStepTwoActive();


    if (
      explicitRef &&
      !stepTwoOpen
    ) {
      forceShow(affiliateCta);
    } else {
      forceHide(affiliateCta);
    }


    if (
      stepTwoOpen ||
      explicitRef ||
      isClinicSearchActive()
    ) {
      forceHide(stepTwoBtn);
    } else {
      forceShow(stepTwoBtn);
    }


    if (explicitRef) {
      forceHide(noProvBtn);
    } else {
      forceShow(noProvBtn);
    }


    if (editCartBtn) {
      if (stepTwoOpen) {
        forceShow(editCartBtn);
      } else {
        forceHide(editCartBtn);
      }
    }
  }


  window.syncAffiliateCartUI = syncUI;


  /* =========================================================
     SEARCH RESULTS
  ========================================================= */

  function clinicSearchString(clinic) {
    return [
      clinic?.name,
      clinic?.address,
      clinic?.city,
      clinic?.state,
      clinic?.zip_code,
      clinic?.phone
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }


  function renderClinicResults() {
    const input = getClinicInput();
    const list = getClinicList();

    if (!input || !list) return;


    const query =
      input.value
        .trim()
        .toLowerCase();


    list.innerHTML = "";


    if (!query) {
      forceHide(list);
      syncUI();
      return;
    }


    if (
      clinicsLoading ||
      (!clinicsLoaded && !clinicsError)
    ) {
      list.innerHTML = `
        <li class="p-4 opacity-60 pointer-events-none">
          Loading providers...
        </li>
      `;

      forceShow(list);
      syncUI();

      return;
    }


    if (
      clinicsError &&
      !clinicsLoaded
    ) {
      list.innerHTML = `
        <li class="p-4">
          <p class="font-medium">
            Providers couldn't be loaded.
          </p>

          <button
            type="button"
            class="affiliate-retry mt-2 underline"
          >
            Try again
          </button>
        </li>
      `;

      forceShow(list);
      syncUI();

      return;
    }


    const matches = clinics
      .filter((clinic) =>
        clinicSearchString(clinic)
          .includes(query)
      )
      .slice(
        0,
        CONFIG.maxSearchResults
      );


    if (!matches.length) {
      list.innerHTML = `
        <li class="p-4 opacity-60 pointer-events-none">
          No providers found.
        </li>
      `;

      forceShow(list);
      syncUI();

      return;
    }


    const fragment =
      document.createDocumentFragment();


    matches.forEach((clinic) => {
      const li =
        document.createElement("li");

      li.className =
        "p-4 border-b hover:bg-gray-100 cursor-pointer";


      li.innerHTML = `
        <p class="clinic-name font-medium">
          ${escapeHtml(clinic.name)}
        </p>

        <p class="opacity-50">
          ${escapeHtml(clinic.address)}
          
          ${escapeHtml(clinic.city)},
          ${escapeHtml(clinic.state)}
          
          ${escapeHtml(clinic.zip_code)}
        </p>
      `;


      li.addEventListener(
        "mousedown",
        (event) => {
          event.preventDefault();
        }
      );


      li.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          displaySelectedClinic(
            clinic,
            false
          );

          forceHide(list);
          syncUI();
        }
      );


      fragment.appendChild(li);
    });


    list.appendChild(fragment);

    forceShow(list);
    syncUI();
  }


  const debouncedClinicSearch =
    debounce(
      renderClinicResults,
      CONFIG.searchDebounce
    );


  /* =========================================================
     SELECT PROVIDER
  ========================================================= */

  function displaySelectedClinic(
    clinic,
    fromLoad = false,
    fullRef = null
  ) {
    if (!clinic) return;


    currentClinic = clinic;

    currentFullRef =
      String(
        fullRef ||
        clinic.sca_ref ||
        ""
      ).trim();


    /*
     * IMPORTANT:
     * For a newly selected provider, save it immediately
     * so the 30-day window starts at selection time.
     */
    if (!fromLoad && currentFullRef) {
      storeScaRef(currentFullRef);
    }


    renderSelectedProviderMirrors(
      clinic,
      currentFullRef
    );

    updateMessageBar(clinic);


    forceHide(getProvHeading());
    forceHide(getClinicInput());

    forceShow(getWithProvBtn());
    forceShow(getNewProvBtn());

    forceHide(getClinicList());


    if (fromLoad) {
      forceHide(getStepTwo());
      forceHide(getStepTwoBtn());
      forceHide(getEditCart());

      const cartItems = getCartItems();

      if (cartItems) {
        cartItems.classList.add("min");
      }
    } else {
      forceShow(getStepTwo());
      forceHide(getStepTwoBtn());
      forceShow(getEditCart());
    }


    bindWithProviderBtn();
    bindNewProviderBtn();
    bindEditCartBtn();

    ensureStepTwoMirrorRendered();

    syncUI();
  }


  /* =========================================================
     INITIALIZE EXISTING PROVIDER
  ========================================================= */

  function findClinicByRef(ref) {
    const fullRef =
      String(ref || "").trim();

    if (!fullRef) return null;


    let found = clinics.find(
      (clinic) =>
        String(clinic.sca_ref || "").trim() ===
        fullRef
    );


    if (found) {
      return found;
    }


    const wantedBase =
      baseRef(fullRef);


    found = clinics.find(
      (clinic) =>
        String(
          baseRef(clinic.sca_ref)
        ) === String(wantedBase)
    );


    return found || null;
  }


  function initializeExistingAffiliate() {
    const ref =
      getExplicitScaRef();

    if (!ref) {
      return false;
    }


    /*
     * Only refresh the 30-day timer when the ref
     * came directly from the URL.
     *
     * A returning user's localStorage read should
     * NOT reset the timer every visit.
     */
    const urlRef =
      getUrlParam("sca_ref");

    if (urlRef) {
      storeScaRef(urlRef);
    }


    const found =
      findClinicByRef(ref);


    if (!found) {
      console.warn(
        "[Affiliate] No API provider matched sca_ref:",
        ref
      );

      presentCartAsProviderSelected();

      return false;
    }


    displaySelectedClinic(
      found,
      true,
      ref
    );


    window.dispatchEvent(
      new CustomEvent(
        "affiliate:capture",
        {
          detail: {
            sca_ref_full: ref,
            sca_ref_base: baseRef(ref),
            affiliate: found
          }
        }
      )
    );


    console.log(
      "[Affiliate] Existing provider:",
      found.name,
      "ref:",
      ref
    );


    return true;
  }


  function presentCartAsProviderSelected() {
    forceHide(getStepTwo());
    forceHide(getStepTwoBtn());
    forceHide(getEditCart());

    forceShow(getAffiliateCta());


    const cartItems = getCartItems();

    if (cartItems) {
      cartItems.classList.add("min");
    }


    syncUI();
  }


  /* =========================================================
     STEP TWO BUTTON
  ========================================================= */

  function bindStepTwoBtn() {
    const btn = getStepTwoBtn();

    if (
      !btn ||
      btn.dataset.affiliateBound === "true"
    ) {
      return;
    }


    btn.dataset.affiliateBound = "true";


    if (!btn.getAttribute("type")) {
      btn.setAttribute(
        "type",
        "button"
      );
    }


    btn.addEventListener(
      "click",
      async (event) => {
        event.preventDefault();


        const stepTwo =
          getStepTwo();


        if (stepTwo) {
          forceShow(stepTwo);
        }


        forceShow(getEditCart());
        forceHide(getStepTwoBtn());


        await ensureStepTwoMirrorRendered();


        if (!clinicsLoaded) {
          loadClinics()
            .then(() => {
              renderClinicResults();
            })
            .catch(() => {
              renderClinicResults();
            });
        }


        stepTwo?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });


        syncUI();
      }
    );
  }


  /* =========================================================
     NEW PROVIDER BUTTON
  ========================================================= */

  function bindNewProviderBtn() {
    const btn = getNewProvBtn();

    if (
      !btn ||
      btn.dataset.affiliateBound === "true"
    ) {
      return;
    }


    btn.dataset.affiliateBound = "true";


    if (!btn.getAttribute("type")) {
      btn.setAttribute(
        "type",
        "button"
      );
    }


    btn.addEventListener(
      "click",
      (event) => {
        event.preventDefault();


        document
          .querySelectorAll(".with-provider")
          .forEach(forceShow);


        forceShow(getProvHeading());
        forceShow(getClinicInput());

        forceHide(getSelProv1());
        forceHide(getNewProvBtn());
        forceHide(getWithProvBtn());
        forceHide(getClinicList());


        const input =
          getClinicInput();

        if (input) {
          input.value = "";

          requestAnimationFrame(
            () => input.focus()
          );
        }


        syncUI();
      }
    );
  }


  /* =========================================================
     EDIT CART
  ========================================================= */

  function bindEditCartBtn() {
    const btn = getEditCart();

    if (
      !btn ||
      btn.dataset.affiliateBound === "true"
    ) {
      return;
    }


    btn.dataset.affiliateBound = "true";


    if (
      btn.tagName === "BUTTON" &&
      !btn.getAttribute("type")
    ) {
      btn.setAttribute(
        "type",
        "button"
      );
    }


    btn.addEventListener(
      "click",
      (event) => {
        event.preventDefault();


        forceHide(getStepTwo());
        forceHide(getEditCart());


        if (!getExplicitScaRef()) {
          forceShow(getStepTwoBtn());
        }


        syncUI();
      }
    );
  }


  /* =========================================================
     OPTIONAL FULL RESET
  ========================================================= */

  function revertToCart() {
    forceHide(getStepTwo());
    forceShow(getStepTwoBtn());
    forceHide(getEditCart());


    const mirrors =
      document.querySelectorAll(
        CONFIG.providerSelectors
      );


    mirrors.forEach((mirror) => {
      forceHide(mirror);

      mirror.innerHTML = "";

      mirror.removeAttribute(
        "data-sca-ref"
      );
    });


    forceShow(getProvHeading());
    forceShow(getClinicInput());

    forceHide(getWithProvBtn());
    forceHide(getNewProvBtn());
    forceHide(getClinicList());


    const input =
      getClinicInput();

    if (input) {
      input.value = "";
    }


    currentClinic = null;
    currentFullRef = "";


    removeScaRef();


    sessionStorage.removeItem(
      "clinicStepContinued"
    );


    const url =
      new URL(location.href);

    url.searchParams.delete(
      "sca_ref"
    );


    history.replaceState(
      {},
      "",
      url.pathname +
        (url.searchParams.toString()
          ? "?" +
            url.searchParams.toString()
          : "") +
        url.hash
    );


    syncUI();
  }


  window.revertAffiliateCart =
    revertToCart;


  /* =========================================================
     WITH PROVIDER / CHECKOUT
  ========================================================= */

  function bindWithProviderBtn() {
    const btn = getWithProvBtn();

    if (
      !btn ||
      btn.dataset.affiliateBound === "true"
    ) {
      return;
    }


    btn.dataset.affiliateBound = "true";


    if (!btn.getAttribute("type")) {
      btn.setAttribute(
        "type",
        "button"
      );
    }


    btn.addEventListener(
      "click",
      (event) => {
        event.preventDefault();


        if (!currentClinic) {
          console.warn(
            "[Affiliate] Checkout clicked without currentClinic."
          );

          return;
        }


        const ref =
          String(
            currentFullRef ||
            currentClinic.sca_ref ||
            ""
          ).trim();


        if (!ref) {
          console.warn(
            "[Affiliate] Selected clinic has no sca_ref."
          );

          return;
        }


        /*
         * Refresh the 30-day timer when user
         * actively confirms the provider.
         */
        storeScaRef(ref);


        const candidate =
          currentClinic.referral_link ||
          currentClinic.custom_referral_link ||
          "/";


        let landing =
          new URL(
            "/",
            location.origin
          );


        try {
          const candidateUrl =
            new URL(
              candidate,
              location.origin
            );


          if (
            candidateUrl.origin ===
            location.origin
          ) {
            landing = candidateUrl;
          }
        } catch (error) {
          console.warn(
            "[Affiliate] Invalid referral link:",
            candidate
          );
        }


        landing.searchParams.set(
          "sca_ref",
          ref
        );


        landing.searchParams.set(
          "sca_after",
          "/checkout"
        );


        landing.searchParams.set(
          "sca_delay",
          "2500"
        );


        const overlay =
          $("checkout-loading-screen");

        if (overlay) {
          forceShow(overlay);
        }


        window.location.href =
          landing.toString();
      }
    );
  }


  /* =========================================================
     CLINIC SEARCH BINDING
  ========================================================= */

  function bindClinicSearch() {
    const input =
      getClinicInput();

    const list =
      getClinicList();


    if (
      !input ||
      !list ||
      input.dataset.affiliateBound === "true"
    ) {
      return;
    }


    input.dataset.affiliateBound = "true";


    input.addEventListener(
      "focus",
      () => {
        if (!clinicsLoaded) {
          loadClinics()
            .then(() => {
              renderClinicResults();
            })
            .catch(() => {
              renderClinicResults();
            });
        }


        if (input.value.trim()) {
          renderClinicResults();
        }


        syncUI();
      }
    );


    input.addEventListener(
      "blur",
      () => {
        setTimeout(
          syncUI,
          50
        );
      }
    );


    input.addEventListener(
      "input",
      () => {
        forceHide(getStepTwoBtn());


        if (
          !clinicsLoaded &&
          !clinicsError
        ) {
          renderClinicResults();
        }


        if (
          !clinicsLoaded &&
          !clinicsLoading
        ) {
          loadClinics()
            .then(() => {
              renderClinicResults();
            })
            .catch(() => {
              renderClinicResults();
            });
        }


        debouncedClinicSearch();
      }
    );
  }


  /* =========================================================
     DELEGATED DOCUMENT EVENTS
  ========================================================= */

  document.addEventListener(
    "click",
    (event) => {
      const retry =
        event.target.closest(
          ".affiliate-retry"
        );


      if (retry) {
        event.preventDefault();


        clinicsError = null;
        clinicsLoaded = false;
        clinicsPromise = null;


        renderClinicResults();


        loadClinics()
          .then(() => {
            renderClinicResults();
          })
          .catch(() => {
            renderClinicResults();
          });


        return;
      }


      const input =
        getClinicInput();

      const list =
        getClinicList();


      if (!input || !list) {
        return;
      }


      if (
        !input.contains(event.target) &&
        !list.contains(event.target)
      ) {
        forceHide(list);
        syncUI();
      }
    }
  );


  /* =========================================================
     THEME / CART RE-RENDER EVENTS
  ========================================================= */

  function refreshAffiliateComponents() {
    bindStepTwoBtn();
    bindNewProviderBtn();
    bindEditCartBtn();
    bindWithProviderBtn();
    bindClinicSearch();


    if (currentClinic) {
      renderSelectedProviderMirrors(
        currentClinic,
        currentFullRef
      );

      updateMessageBar(
        currentClinic
      );

      ensureStepTwoMirrorRendered();
    }


    syncUI();
  }


  document.addEventListener(
    "drawer:reloaded",
    refreshAffiliateComponents
  );


  document.addEventListener(
    "cart:refresh",
    refreshAffiliateComponents
  );


  window.addEventListener(
    "drawer:reloaded",
    refreshAffiliateComponents
  );


  window.addEventListener(
    "cart:refresh",
    refreshAffiliateComponents
  );


/* =========================================================
   SCOPED CART OBSERVER

   Never observe document.body.
   Provider search results should NOT trigger
   a complete affiliate UI refresh.
========================================================= */

const cartRoot =
  document.querySelector("#cart-drawer") ||
  document.querySelector("#CartDrawer") ||
  document.querySelector("[data-cart-drawer]");


if (cartRoot) {
  const cartObserver =
    new MutationObserver((mutations) => {
      /*
       * Ignore mutations that happen entirely
       * inside provider search results.
       */
      const meaningfulMutation =
        mutations.some((mutation) => {
          const target =
            mutation.target instanceof Element
              ? mutation.target
              : mutation.target.parentElement;

          if (!target) {
            return false;
          }

          if (
            target.closest("#clinic-results") ||
            target.closest("#clinic-input")
          ) {
            return false;
          }

          return true;
        });


      if (!meaningfulMutation) {
        return;
      }


      clearTimeout(observerTimer);

      observerTimer =
        setTimeout(() => {
          refreshAffiliateComponents();
        }, 100);
    });


  cartObserver.observe(
    cartRoot,
    {
      childList: true,
      subtree: true
    }
  );
}


  /* =========================================================
     INITIAL LAYOUT
  ========================================================= */

  function initialLayout() {
    const cartItems =
      getCartItems();

    const existingRef =
      getExplicitScaRef();


    if (existingRef) {
      forceHide(getStepTwo());
      forceHide(getStepTwoBtn());
      forceHide(getEditCart());


      if (cartItems) {
        cartItems.classList.add(
          "min"
        );
      }
    } else {
      forceHide(getStepTwo());
      forceShow(getStepTwoBtn());
      forceHide(getAffiliateCta());
      forceHide(getEditCart());
    }


    syncUI();
  }


  /* =========================================================
     BOOT
  ========================================================= */

  function bootAffiliateCart() {
  /*
   * Bind cart/provider UI immediately.
   *
   * No network request is required for this.
   */
  refreshAffiliateComponents();

  initialLayout();


  const existingRef =
    getExplicitScaRef();


  /*
   * Only load the affiliate database
   * immediately if the shopper ALREADY
   * has an affiliate/provider reference.
   *
   * Everyone else loads providers only
   * when they actually use provider search.
   */
  if (existingRef) {
    loadClinics()
      .then(() => {
        initializeExistingAffiliate();


        const input =
          getClinicInput();


        if (
          input &&
          input.value.trim()
        ) {
          renderClinicResults();
        }


        syncUI();
      })
      .catch(error => {
        /*
         * Do not block or break the cart
         * just because affiliate API failed.
         */
        if (
          error?.status !== 401 &&
          error?.status !== 403
        ) {
          console.warn(
            "[Affiliate] Existing affiliate could not be initialized:",
            error
          );
        }


        syncUI();
      });
  }


  /*
   * Initial UI should not wait on API.
   */
  syncUI();

  requestAnimationFrame(
    syncUI
  );
}


bootAffiliateCart();


/* =========================================================
   BOUNCE BACK TO CHECKOUT
========================================================= */

(function bounceBackToCheckout() {
  const params =
    new URLSearchParams(
      location.search
    );


  const next =
    params.get("sca_after");


  if (!next) return;


  const delay =
    Math.max(
      100,
      parseInt(
        params.get("sca_delay"),
        10
      ) || 2500
    );


  const overlay =
    document.getElementById(
      "checkout-loading-screen"
    );


  if (overlay) {
    overlay.classList.remove(
      "hidden"
    );
  }


  let target;


  try {
    target =
      new URL(
        next,
        location.origin
      );
  } catch (error) {
    console.error(
      "[Affiliate] Invalid checkout target:",
      next
    );

    return;
  }


  if (
    target.origin !==
    location.origin
  ) {
    console.warn(
      "[Affiliate] Cross-origin bounce prevented:",
      target.toString()
    );

    return;
  }


  const alreadyThere =
    location.origin +
      location.pathname ===
    target.origin +
      target.pathname;


  if (alreadyThere) {
    return;
  }


  setTimeout(() => {
    params.delete(
      "sca_after"
    );

    params.delete(
      "sca_delay"
    );


    const cleanUrl =
      location.pathname +
      (params.toString()
        ? "?" + params.toString()
        : "") +
      location.hash;


    history.replaceState(
      {},
      "",
      cleanUrl
    );


    window.location.href =
      target.toString();
  }, delay);
})();
 });